/**
 * Premium User Check Utilities
 */

/**
 * Check if user is a premium subscriber
 * @param {Object} userSubscription - User subscription object from startupContents
 * @returns {boolean} True if user has Premium subscription
 */
export const isPremiumUser = (userSubscription) => {
    return userSubscription?.subscriptionType?.toLowerCase() === "premium" && userSubscription?.isActive;
};

/**
 * Check if subscription is active and valid
 * @param {Object} userSubscription - User subscription object from startupContents
 * @returns {boolean} True if subscription is active
 */
export const isSubscriptionActive = (userSubscription) => {
    return userSubscription?.isActive === true;
};

/**
 * Get subscription type
 * @param {Object} userSubscription - User subscription object from startupContents
 * @returns {string} Subscription type (e.g., "Basic", "Premium")
 */
export const getSubscriptionType = (userSubscription) => {
    return userSubscription?.subscriptionType || "Basic";
};

/**
 * Check if user is on trial
 * @param {Object} userSubscription - User subscription object from startupContents
 * @returns {boolean} True if user is on trial
 */
export const isTrialUser = (userSubscription) => {
    return userSubscription?.isTrial === true;
};
